import React, { useState } from 'react';

export default function HistoryPanel({ gameState }) {
  const [expandedVote, setExpandedVote] = useState(null);

  if (!gameState) return null;

  const { voteHistory = [], questHistory = [] } = gameState;

  if (voteHistory.length === 0 && questHistory.length === 0) return null;

  return (
    <div className="mod-section">
      <div className="mod-section-title">Game History</div>

      {/* Quest History */}
      {questHistory.length > 0 && (
        <div className="history-group">
          <div className="history-group-title">Quest Results</div>
          {questHistory.map((q, i) => (
            <div key={i} className="history-item">
              <div className="history-item-header">
                <span>Quest {q.questIndex + 1}</span>
                <span className={`vote-badge ${q.success ? 'approve' : 'reject'}`}>
                  {q.success ? 'Success' : 'Failed'}
                </span>
              </div>
              <div className="history-item-detail">
                Team: {q.team.join(', ')}
              </div>
              <div className="history-item-detail">
                Cards: {q.successCount} Success / {q.failCount} Fail
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Vote History */}
      {voteHistory.length > 0 && (
        <div className="history-group">
          <div className="history-group-title">Vote History</div>
          {voteHistory.map((v, i) => (
            <div
              key={i}
              className="history-item history-item-clickable"
              onClick={() => setExpandedVote(expandedVote === i ? null : i)}
            >
              <div className="history-item-header">
                <span>Q{v.questIndex + 1} - {v.leaderName}'s team</span>
                <span className={`vote-badge ${v.approved ? 'approve' : 'reject'}`}>
                  {v.approved ? 'Approved' : 'Rejected'} ({v.approves}-{v.rejects})
                </span>
              </div>
              <div className="history-item-detail">
                Team: {v.team.join(', ')}
              </div>
              {expandedVote === i && v.voteDetails && (
                <div className="history-votes">
                  {Object.entries(v.voteDetails).map(([pid, { name, vote }]) => (
                    <div key={pid} className="vote-result-item" style={{ fontSize: '0.8rem' }}>
                      <span>{name}</span>
                      <span className={`vote-badge ${vote}`}>
                        {vote === 'approve' ? 'Approve' : 'Reject'}
                      </span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
